import { render, staticRenderFns } from "./SubscribeHeroAiCoinsCard.vue?vue&type=template&id=75710e83&scoped=true&"
import script from "./SubscribeHeroAiCoinsCard.vue?vue&type=script&lang=js&"
export * from "./SubscribeHeroAiCoinsCard.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeHeroAiCoinsCard.vue?vue&type=style&index=0&id=75710e83&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75710e83",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SubscribeHero2026AiPartners: require('/opt/render/project/src/channels2022/src/components/subscribe2026/SubscribeHero2026AiPartners.vue').default})
